module.exports = __webpack_public_path__ + "img/micphone_on.d5916be9.png";